/**
 * Label and control styling for the hand-rolled admin forms. Shared so a field
 * pulled out into its own component still matches the fields sitting next to it.
 */
export const LABEL_CLASS =
    'block text-[11px] font-semibold uppercase tracking-wide text-ink-500 mb-1'

export const FIELD_CLASS =
    'w-full rounded-lg border border-ink-200 bg-white px-3 py-2 text-sm text-ink-900 focus:border-arwen-500 focus:outline-none focus:ring-1 focus:ring-arwen-500'
